import * as React from "react";
import { useEffect, useState } from "react";
import { OutboundLink } from "gatsby-plugin-google-analytics";
import MainLogo from "../components/logo";
import { Link } from "gatsby";
import BurgerMenu from "../components/menu";
import { Newsletter } from "../components/newsletter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { faAmazon } from "@fortawesome/free-brands-svg-icons";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import SearchBar from "../components/search";
library.add(fab, faAmazon);

const menu = [
  {
    link_url: "/",
    link_title: "Home",
  },
  {
    link_url: "/articles/",
    link_title: "Articles",
  },
  {
    link_url: "/hubs/",
    link_title: "Courses",
  },
  {
    link_url: "/free-play/",
    link_title: "Free-to-Play",
  },
  {
    link_url: "/services/",
    link_title: "Services",
  },
  {
    link_url: "/shop/",
    link_title: "Shop",
  },
  {
    link_url: "/about/",
    link_title: "About",
  },
];

const socials = [
  {
    link_icon: "youtube",
    link_url: "https://www.youtube.com/user/TheVegasAces",
    link_title: "YouTube",
  },
  {
    link_icon: "facebook",
    link_url: "https://www.facebook.com/pages/Vegas-Aces/126216680732741",
    link_title: "Facebook",
  },
  {
    link_icon: "twitter",
    link_url: "https://twitter.com/vegas_aces",
    link_title: "Twitter",
  },
  {
    link_icon: "tiktok",
    link_url: "https://www.tiktok.com/@vegas.aces",
    link_title: "TikTok",
  },
  {
    link_icon: "linkedin",
    link_url: "https://www.linkedin.com/in/heather-ferris/",
    link_title: "LinkedIn",
  },
  {
    link_icon: "instagram",
    link_url: "https://www.instagram.com/vegas_aces_/",
    link_title: "Instagram",
  },
  {
    link_icon: "paypal",
    link_url: "https://www.paypal.com/donate/?hosted_button_id=ZMJ7T2NAX49GG",
    link_title: "PayPal",
  },
  {
    link_icon: "patreon",
    link_url: "https://www.patreon.com/vegasaces",
    link_title: "Patreon",
  },
];

const footerColumns = [
  {
    title: "Merch",
    text: "Support and get something directly back by picking up gear or a lucky trinket.",
    link: "/shop/",
    icon: <FontAwesomeIcon icon={faShoppingCart} />,
    button: "Shop Now",
  },
  {
    title: "Patreon",
    text: "Access years of exclusive content immediately for a small monthly commitment.",
    url: "https://www.patreon.com/vegasaces",
    icon: <FontAwesomeIcon icon={["fab", "patreon"]} />,
    button: "Become a Patron",
  },
  {
    title: "Tips",
    text: "One of the first things we teach players is to tip their dealer. We accept PayPal!",
    url: "https://www.paypal.com/donate/?hosted_button_id=ZMJ7T2NAX49GG",
    icon: <FontAwesomeIcon icon={["fab", "paypal"]} />,
    button: "Leave a Tip",
  },
];

export const useScrollHandler = () => {
  const [scroll, setScroll] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const scrollCheck = window.scrollY > 50;
      setScroll(scrollCheck);
    };
    document.addEventListener("scroll", onScroll);
    return () => {
      document.removeEventListener("scroll", onScroll);
    };
  }, [scroll, setScroll]);

  return scroll;
};

export const Layout = ({ children }) => {
  const scroll = useScrollHandler();

  return (
    <div className="flex flex-col min-h-screen">
      <header
        className={[
          "transition-all ease-in-out duration-300 fixed w-full py-2 z-50 bg-white/100 ",
          scroll && " !bg-white/75 py-0",
        ]}
      >
        <div className="container mx-auto">
          <div className="flex content-center items-center flex-wrap lg:flex-no-wrap">
            <div className="flex-1 lg:flex-none order-1 font-bold font-sans inline-block px-3 py-1">
              <Link
                to="/"
                title="Vegas Aces"
                className="flex transition-all ease-in-out duration-300 content-center items-center relative z-50"
              >
                <MainLogo scroll={scroll} />
                <span className="sr-only">Vegas Aces</span>
              </Link>
            </div>
            <div className="order-3 lg:flex-1 flex justify-end px-4">
              <BurgerMenu
                right
                width={"100%"}
                links={menu}
                burgerButtonClassName={
                  "block lg:hidden w-[30px] bg-white p-1 py-[2px]"
                }
                burgerBarClassName={
                  "block bg-black rounded !opacity-100 !w-full !h-[2px] !relative !top-auto !right-auto !left-auto m-0 my-[4px]"
                }
                overlayClassName={
                  "!bg-black left-0 top-0 !h-screen !opacity-90 transition-all ease-in-out duration-300"
                }
                menuClassName={"py-2 left-0"}
              />
              <div className="hidden lg:block relative">
                {menu.map((item) => (
                  <Link
                    key={item.link_url}
                    to={item.link_url}
                    title=""
                    className={[
                      "transition-all ease-in-out duration-300 mr-5 ",
                      scroll ? " text-sm" : "",
                    ]}
                    activeClassName="text-felt-500 font-bold underline underline-offset-4 decoration-2"
                  >
                    {item.link_title}
                  </Link>
                ))}
                <SearchBar />
              </div>
            </div>
          </div>
        </div>
      </header>
      <main className="flex-grow z-0">{children} </main>{" "}
      <footer>
        <div className="py-8 px-3 bg-felt-50 text-center">
          <div className="container mx-auto px-3 2xl:px-0">
            <h2 className="font-extrabold font-semi-expanded text-3xl tracking-tight mb-2">
              Your support keeps this site free.
            </h2>
            <p className="md:text-xl leading-relaxed mb-2 max-w-lg mx-auto">
              We believe in making education and information as accessible as
              possible. Help us keep the lights on by supporting financially.
              Every bit counts!
            </p>
            <div className="grid grid-cols-1 gap-x-24 gap-y-5 md:grid-cols-3 max-w-5xl mx-auto mt-8">
              {footerColumns.map((item) => {
                var buttonStyles =
                  "transition-all ease-in-out duration-300 inline-block bg-felt-500 text-white rounded py-2 px-5 hover:bg-felt-600 font-bold";
                return (
                  <div className="text-center" key={item.title}>
                    <h3 className="font-extrabold font-expanded uppercase text-2xl mb-2">
                      {item.title}
                    </h3>
                    <p className="text-sm lg:text-base mb-3">{item.text}</p>
                    {item.link && (
                      <Link to={item.link} title="" className={buttonStyles}>
                        {item.button}
                        <span className="ml-3">{item.icon}</span>
                      </Link>
                    )}
                    {item.url && (
                      <OutboundLink href={item.url} className={buttonStyles}>
                        {item.button}
                        <span className="ml-3">{item.icon}</span>
                      </OutboundLink>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <Newsletter />
        <div className="bg-zinc-800 text-white px-3">
          <div className="container mx-auto px-3 2xl:px-0">
            <div className="py-5 grid grid-cols-1 lg:grid-cols-2 gap-2 font-sans text-sm">
              <div className="text-center lg:text-left">
                <p>
                  Join over 1,500 Vegas Aces students at{" "}
                  <a
                    href="https://curious.com/vegasaces"
                    target="_blank"
                    rel="noreferrer"
                    className="text-felt-500"
                  >
                    Curious.com
                  </a>
                </p>
              </div>
              <div className="text-center lg:text-right">
                <p>
                  Join in the conversation at{" "}
                  <a
                    href="https://www.tapatalk.com/groups/vegasaces/index.php#.V2D4zPkrKUl"
                    target="_blank"
                    className="text-felt-500"
                    rel="noreferrer"
                  >
                    Tapatalk
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="py-4 bg-zinc-900 text-white px-3">
          <div className="container mx-auto px-3 2xl:px-0">
            <div className="py-5 grid grid-cols-1 lg:grid-cols-2 gap-2 text-center lg:text-left">
              <div className="flex lg:block flex-wrap justify-center px-5 lg:px-0 mb-5 lg:mb-0">
                {menu.map((item) => (
                  <Link
                    key={item.link_url}
                    to={item.link_url}
                    title=""
                    className="transition-all ease-in-out duration-300 mx-1 lg:mx-0 lg:mr-5 hover:text-zinc-200 text-sm lg:text-base"
                    activeClassName="font-extrabold"
                  >
                    {item.link_title}
                  </Link>
                ))}
              </div>
              <div className="text-center lg:text-right px-5 lg:px-0">
                {socials.map((item) => (
                  <a
                    key={item.link_url}
                    href={item.link_url}
                    title={item.link_title}
                    target="_blank"
                    rel="noreferrer"
                    className="text-xl px-3 lg:px-0 lg:pl-5 hover:text-zinc-200 transition-all ease-in-out duration-300"
                  >
                    <FontAwesomeIcon icon={["fab", item.link_icon]} />
                  </a>
                ))}
              </div>
            </div>
            <p className="text-xs lg:text-sm text-zinc-500 text-center py-5">
              Copyright © 2010-{new Date().getFullYear()} Vegas Aces Services,
              LLC <span className="hidden lg:inline">·</span>{" "}
              <span className="block lg:inline">All rights reserved.</span>
            </p>
          </div>
        </div>
      </footer>{" "}
    </div>
  );
};

export default Layout;
